import PostBookingResultsWrapper from './postbookingresults/PostBookingResultsWrapper';
import ItineraryCardWrapper from './itinerarycard/ItineraryCardWrapper';
import PlanMyCruiseContainerWrapper from './planmycruisecontainer/PlanMyCruiseContainerWrapper';
import DayTabsWrapper from './daytabs/dayTabsWrapper';
import UserLogoutWrapper from './userlogout/UserLogoutWrapper';
import AllMyCruisesWrapper from './planmycruisecontainer/overviewcontainer/allmycruises/AllMyCruisesWrapper';
import NavigationMenuWrapper from './navigationmenu/NavigationMenuWrapper';
import LightLoginWrapper from './lightlogin/LightLoginWrapper';
import FullLoginActionButtonWrapper from './login/fullloginactionbutton/FullLoginActionButtonWrapper';
import FullLoginTokenExchangeWrapper from './login/fulllogintokenexchange/FullLoginTokenExchangeWrapper';
import ExploreByDayCarouselWrapper from './explorebydaycarousel/ExploreByDayCarouselWrapper';
import FilterDrawerContainerWrapper from './filterdrawercontainer/FilterDrawerContainerWrapper';
import CategoryFilterWrapper from './categoryfilter/CategoryFilterWrapper';
import ProductCarouselWrapper from './productcarousel/ProductCarouselWrapper';
import EssentialsCarouselWrapper from './essentialscarousel/EssentialsCarouselWrapper';
import RegisterWrapper from './register/RegisterWrapper';
import WebCheckinWrapper from './webcheckin/WebCheckinWrapper';
import { CustomerInformationContainerWrapper } from './customerinformationcontainer/CustomerInformationContainerWrapper';
import AddExistingBookingWrapper from './addexistingbooking/AddExistingBookingWrapper';
import StateroomDetailsWrapper from './stareroomdetails/StateroomDetailsWrapper';
import CruiseDetailsContainerWrapper from './cruisedetailscontainer/CruiseDetailsContainerWrapper';
import EticketEmitWrapper from './eticketemit/EticketEmitWrapper';
import OrderNotesWrapper from './orderNotes/OrderNotesWrapper';
import StepperWidgetWrapper from './stepperwidget/StepperWidgetWrapper';
import GuestInfoWrapper from './guestinfo/GuestInfoWrapper';
import PaymentWrapper from './payment/PaymentWrapper';
import { Recaptcha } from './recaptcha/Recaptcha';
import PurchaseRestrictionModalWrapper from './purchaserestrictionmodal/PurchaseRestrictionModalWrapper';
import CartContainerWrapper from './cartcheckout/cartcontainer/CartContainerWrapper';
import CheckoutContainerWrapper from './cartcheckout/checkoutcontainer/CheckoutContainerWrapper';
import AlreadyPurchasedContainerWrapper from './alreadypurchasedcontainer/AlreadyPurchasedContainerWrapper';
import VoyagersClubMainContainerWrapper from './voyagersclubmaincontainer/VoyagersClubMainContainerWrapper';
import VoyagersClubNoMembershipContainerWrapper from './voyagersclubnomembershipcontainer/VoyagersClubNoMembershipContainerWrapper';
import VoyagersClubMembershipContainerWrapper from './voyagersclubmembershipcontainer/VoyagersClubMembershipContainerWrapper';
import VoyagersClubJoinMscVoyagerClubWrapper from './voyagersclubjoinmscvoyagerclub/VoyagersClubJoinMscVoyagerClubWrapper';
import VoyagersClubAlreadyMemberWrapper from './voyagersclubalreadymember/VoyagersClubAlreadyMemberWrapper';
import VoyagerClubMembershipDetailsWrapper from './voyagersclubmembershipdetails/VoyagerClubMembershipDetailsWrapper';
import VoyagerClubTeaserWrapper from './VoyagersClubTeaser/VoyagerClubTeaserWrapper';
import DownloadPDFWrapperLazy from './downloadPdf/DownloadPDFWrapperLazy';
import VoyagersClubMembershipPointsRecapWrapper from './voyagersclubmembershippointsrecap/VoyagersClubMembershipPointsRecapWrapper';

export const wrappers = [
  NavigationMenuWrapper,
  PostBookingResultsWrapper,
  ItineraryCardWrapper,
  PlanMyCruiseContainerWrapper,
  AllMyCruisesWrapper,
  DayTabsWrapper,
  OrderNotesWrapper,
  UserLogoutWrapper,
  LightLoginWrapper,
  FullLoginActionButtonWrapper,
  FullLoginTokenExchangeWrapper,
  ExploreByDayCarouselWrapper,
  FilterDrawerContainerWrapper,
  CategoryFilterWrapper,
  ProductCarouselWrapper,
  EssentialsCarouselWrapper,
  DownloadPDFWrapperLazy,
  RegisterWrapper,
  WebCheckinWrapper,
  CustomerInformationContainerWrapper,
  AddExistingBookingWrapper,
  StateroomDetailsWrapper,
  CruiseDetailsContainerWrapper,
  StepperWidgetWrapper,
  EticketEmitWrapper,
  GuestInfoWrapper,
  PaymentWrapper,
  Recaptcha,
  PurchaseRestrictionModalWrapper,
  CartContainerWrapper,
  CheckoutContainerWrapper,
  AlreadyPurchasedContainerWrapper,
  VoyagersClubMainContainerWrapper,
  VoyagersClubNoMembershipContainerWrapper,
  VoyagersClubMembershipContainerWrapper,
  VoyagersClubJoinMscVoyagerClubWrapper,
  VoyagersClubAlreadyMemberWrapper,
  VoyagerClubMembershipDetailsWrapper,
  VoyagerClubTeaserWrapper,
  VoyagersClubMembershipPointsRecapWrapper,
];
